import { Notification, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { CampaignBenefit } from "../CampaignBenefit";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";

export const CampaignNotification = () => {
    const {
        campaignDuration,
        campaignBenefits,
        campaignCms: {
            lowerCommission,
            lowerCommissionDescription,
            fasterPayout,
            fasterPayoutDescription,
            lowerCommissionAndFasterPayout,
            lowerCommissionAndFasterPayoutDescription,
            offerExcludesNorthAmericaAndIndia,
        },
    } = usePropertySelectionViewModelValue();

    const isCommissionReduction = campaignBenefits.includes(CampaignBenefit.CommissionReduction);
    const isFasterPayout = campaignBenefits.includes(CampaignBenefit.TtPlusOne);

    if (!isCommissionReduction && !isFasterPayout) return null;

    const notificationText: { title: string; description: string } | null =
        isCommissionReduction && isFasterPayout
            ? {
                  title: lowerCommissionAndFasterPayout,
                  description: lowerCommissionAndFasterPayoutDescription,
              }
            : isCommissionReduction
              ? {
                    title: lowerCommission,
                    description: lowerCommissionDescription,
                }
              : isFasterPayout
                ? {
                      title: fasterPayout,
                      description: fasterPayoutDescription,
                  }
                : null;

    return (
        <VStack gap="8" mb="24" data-testid="campaign-notification" data-element-name="campaign-notification">
            <Notification
                intent="positive"
                asset={{ id: "fill.symbol.tag" }}
                title={notificationText?.title}
                description={notificationText?.description?.replace("{0}", campaignDuration.toString())}
            />
            <Typography variant="caption-default" textColor="base.subtle">
                {offerExcludesNorthAmericaAndIndia}
            </Typography>
        </VStack>
    );
};
